export default {
  label: {
    yAxisTitle: 'Publicaciones',
  },
};
